export enum FormBuilderElementInputTypeIdentifier {
	Unknown = 0,
	Text = 1,
	Number = 2,
	Date = 3,
	Checkbox = 4,
	TextArea = 5
}
